import { PAGINATION_CONSTANTS } from '../../constants'
import { getDefaultMargin, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const GalleryDesignSettings = {
  // Width
  'gallery-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'gallery-design-search-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
  },

  // alignment
  'gallery-design-comp-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'gallery-design-comp-title-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'gallery-design-group-header-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'gallery-design-search-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'gallery-design-pagination-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'gallery-design-comp-items-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  // Layout
  'gallery-design-layout': {
    phone: 'grid',
    'phone-landscape': 'grid',
    tablet: 'grid',
    'tablet-landscape': 'grid',
    desktop: 'grid',
    tv: 'grid',
  },
  'gallery-data-num-item': {
    phone: 10,
    'phone-landscape': 10,
    tablet: 10,
    'tablet-landscape': 10,
    desktop: 10,
    tv: 10,
  },
  'gallery-design-num-cols': {
    phone: 2,
    'phone-landscape': 3,
    tablet: 2,
    'tablet-landscape': 3,
    desktop: 4,
    tv: 4,
  },
  'gallery-design-num-rows': {
    phone: 2,
    'phone-landscape': 3,
    tablet: 2,
    'tablet-landscape': 3,
    desktop: 4,
    tv: 4,
  },
  'gallery-design-pagination': {
    phone: false,
    'phone-landscape': false,
    tablet: false,
    'tablet-landscape': false,
    desktop: false,
    tv: false,
  },

  'gallery-default-per-page': {
    phone: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    'phone-landscape': PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    tablet: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    'tablet-landscape': PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    desktop: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
    tv: PAGINATION_CONSTANTS.DEFAULT_PER_PAGE,
  },
  // Spacing
  'gallery-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'gallery-design-headline-margin': {
    phone: getDefaultMargin([20, 0]),
    'phone-landscape': getDefaultMargin([20, 0]),
    tablet: getDefaultMargin([20, 0]),
    'tablet-landscape': getDefaultMargin([20, 0]),
    desktop: getDefaultMargin([20, 0]),
    tv: getDefaultMargin([20, 0]),
  },
  'gallery-design-group-header-margin': {
    phone: getDefaultMargin([20, 0]),
    'phone-landscape': getDefaultMargin([20, 0]),
    tablet: getDefaultMargin([20, 0]),
    'tablet-landscape': getDefaultMargin([20, 0]),
    desktop: getDefaultMargin([20, 0]),
    tv: getDefaultMargin([20, 0]),
  },
  'gallery-design-gap': {
    phone: { value: 8, unit: 'px' },
    'phone-landscape': { value: 8, unit: 'px' },
    tablet: { value: 8, unit: 'px' },
    'tablet-landscape': { value: 8, unit: 'px' },
    desktop: { value: 8, unit: 'px' },
    tv: { value: 8, unit: 'px' },
  },
  'gallery-design-search-margin': {
    phone: getDefaultMargin([0, 0, 12]),
    'phone-landscape': getDefaultMargin([0, 0, 12]),
    tablet: getDefaultMargin([0, 0, 12]),
    'tablet-landscape': getDefaultMargin([0, 0, 12]),
    desktop: getDefaultMargin([0, 0, 12]),
    tv: getDefaultMargin([0, 0, 12]),
  },
  'gallery-design-filter-margin': {
    phone: getDefaultMargin([0, 0, 12]),
    'phone-landscape': getDefaultMargin([0, 0, 12]),
    tablet: getDefaultMargin([0, 0, 12]),
    'tablet-landscape': getDefaultMargin([0, 0, 12]),
    desktop: getDefaultMargin([0, 0, 12]),
    tv: getDefaultMargin([0, 0, 12]),
  },

  // Aspect Ratio
  'gallery-design-aspect-ratio': {
    phone: '1:1',
    'phone-landscape': '1:1',
    tablet: '1:1',
    'tablet-landscape': '1:1',
    desktop: '1:1',
    tv: '1:1',
  },

  // (nested) typography
  'gallery-design-typography': {
    'gallery-design-caption-typography': {
      phone: getDefaultTypography('Label Small'),
      'phone-landscape': getDefaultTypography('Label Small'),
      tablet: getDefaultTypography('Label Small'),
      'tablet-landscape': getDefaultTypography('Label Small'),
      desktop: getDefaultTypography('Label Small'),
      tv: getDefaultTypography('Label Small'),
    },
    'gallery-design-tag-typography': {
      phone: getDefaultTypography('Label Small'),
      'phone-landscape': getDefaultTypography('Label Small'),
      tablet: getDefaultTypography('Label Small'),
      'tablet-landscape': getDefaultTypography('Label Small'),
      desktop: getDefaultTypography('Label Small'),
      tv: getDefaultTypography('Label Small'),
    },
    'gallery-design-comp-title-typography': {
      phone: getDefaultTypography('headline-small'),
      'phone-landscape': getDefaultTypography('headline-small'),
      tablet: getDefaultTypography('headline-small'),
      'tablet-landscape': getDefaultTypography('headline-small'),
      desktop: getDefaultTypography('headline-small'),
      tv: getDefaultTypography('headline-small'),
    },
    'gallery-design-group-header-typography': {
      phone: getDefaultTypography('Title Medium'),
      'phone-landscape': getDefaultTypography('Title Medium'),
      tablet: getDefaultTypography('Title Medium'),
      'tablet-landscape': getDefaultTypography('Title Medium'),
      desktop: getDefaultTypography('Title Medium'),
      tv: getDefaultTypography('Title Medium'),
    },
  },

  // Carousel settings
  'gallery-design-carousel-arrow': {
    phone: true,
    'phone-landscape': true,
    tablet: true,
    'tablet-landscape': true,
    desktop: true,
    tv: true,
  },
  'gallery-design-carousel-indicator': {
    phone: false,
    'phone-landscape': false,
    tablet: false,
    'tablet-landscape': false,
    desktop: false,
    tv: false,
  },

  // layout
  'array-gallery-design-layout': {
    phone: 'grid',
    'phone-landscape': 'grid',
    tablet: 'grid',
    'tablet-landscape': 'grid',
    desktop: 'grid',
    tv: 'grid',
  },
  'array-gallery-design-carousel-arrow': {
    phone: true,
    'phone-landscape': true,
    tablet: true,
    'tablet-landscape': true,
    desktop: true,
    tv: true,
  },
  'array-gallery-design-carousel-indicator': {
    phone: false,
    'phone-landscape': false,
    tablet: false,
    'tablet-landscape': false,
    desktop: false,
    tv: false,
  },
}
